import makeStyles from '@material-ui/core/styles/makeStyles';

export const useStyles = makeStyles(() => ({
  spinner: {},
  left: {
    marginLeft: 10,
  },
  right: {
    marginRight: 10,
  },
}));
